// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"Custom100ControlBatchDetail_actionsWrapper__1kyAR"};